import { isDefined, Nullable } from "@cak-legacy/core-utils";

type InvokeFn = (...args: any[]) => any;
type InvokeArgs<T> = T extends (...args: infer A) => any ? A : never;
type InvokeReturn<T> = T extends (...args: any[]) => infer R ? R : never;

export const invoke = <T extends InvokeFn>(fn: Nullable<T>, ...args: InvokeArgs<T>): InvokeReturn<T> => {
  return isDefined(fn) ? fn(...args) : undefined;
};

export const invokeWhen = <T extends InvokeFn>(
  predicate: () => boolean,
  fn: Nullable<T>,
  ...args: InvokeArgs<T>
): Nullable<InvokeReturn<T>> => {
  return predicate() ? invoke(fn, ...args) : undefined;
};
